<template>
  <v-list subheader>
    <v-list-item v-for="item in words" :key="item.index">
      <v-list-item-content>
        <v-list-item-title
          v-text="item.word"
          :class="item.color_class"
        ></v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import refs from "./firebase/refs";

export default {
  name: "CurrentTurnWords",
  props: {
    gameId: String,
  },
  components: {},
  created() {
    this.listenForCurrentTurn();
  },
  methods: {
    listenForCurrentTurn() {
      refs.currentTurnWords(this.gameId).on("value", (snap) => {
        this.words = [];
        snap.forEach((wordSnap) => {
          this.words.push({
            word: wordSnap.val().word,
            color_class: this.getDisplayColorClass(wordSnap.val().status),
          });
        });
      });
    },
    getDisplayColorClass(wordStatus) {
      switch (wordStatus) {
        case "correct":
          return "green--text";
        case "taboo":
          return "red--text";
        default:
          return "black--text";
      }
    },
  },
  data() {
    return {
      words: [],
    };
  },
};
</script>
